import { useEffect } from 'react';
import useTranslation from '../../states/translation/useTranslation';
import EligibilityWidgetCard from './EligibilityWidgetCard';
import EligibilityWidgetTokenStatus from './EligibilityWidgetTokenStatus';
import ResetAction from './ResetAction';
import { useLocation, useNavigate, useRouteError, useSearchParams } from 'react-router-dom';
import useLog from '../../libs/utils/log/useLog';
import ErrorStatus from '../../../types/errors/ErrorStatus';

interface EligibilityWidgetErrorProps {
  pid: string;
  apiKey: string;
  language: string;
}

const EligibilityWidgetError: React.FC<EligibilityWidgetErrorProps> = ({ pid, apiKey, language }) => {
  const { t } = useTranslation().actions;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const error = useRouteError();
  const { logError } = useLog().actions;
  const location = useLocation();

  useEffect(() => {
    logError(ErrorStatus.ELIGIBILITY_WIDGET_ERROR, {
      pid,
      requestId: '',
      apiKey,
      language,
      error: String(error),
    });
  }, [error]);

  return (
    <EligibilityWidgetCard>
      <EligibilityWidgetTokenStatus
        header={t('offer.out-of-luck.title')}
        body={t('offer.out-of-luck.text')}
        dataTestId="eligibility-widget.error"
      >
        <ResetAction
          onClick={() =>
            navigate(
              {
                pathname: location.pathname,
                search: searchParams.toString(),
              },
              { replace: true },
            )
          }
        />
      </EligibilityWidgetTokenStatus>
    </EligibilityWidgetCard>
  );
};

export default EligibilityWidgetError;
